import { isDev } from "@studiometa/js-toolkit/utils";
function withDeprecation(BaseClass, message) {
  class Deprecated extends BaseClass {
    /**
     * Config.
     */
    static config = {
      name: "Deprecated"
    };
    onMounted() {
      if (isDev) {
        console.warn(
          `The ${this.$options.name} component is deprecated.`,
          message ? `
${message}` : ""
        );
      }
    }
  }
  return Deprecated;
}
export {
  withDeprecation
};
//# sourceMappingURL=withDeprecation.js.map
